import * as Sentry from "@sentry/react";
import { translationContext } from "./detect";

export type DomMutationOp = "removeChild" | "insertBefore" | "global-handler";

/** Un evento por sesión y por tipo de operación. Ver 01 §6. */
const reported = new Set<DomMutationOp>();

interface ReportInput {
  op: DomMutationOp;
  parent?: Node | null;
  child?: Node | null;
  error?: Error;
}

export function reportDomMutation({ op, parent, child, error }: ReportInput) {
  if (reported.has(op)) return;
  reported.add(op);

  // NUNCA textContent / innerHTML / outerHTML / value: pueden llevar PII
  // o contenido de chat del usuario. Ver 01 §5 y contracts.sentry_event.
  Sentry.captureException(error ?? new Error(`DOM mutation absorbed: ${op}`), {
    level: "warning",
    tags: { dom_mutation: op },
    extra: {
      ...translationContext(),
      parentTag: parent instanceof Element ? parent.tagName : "",
      childNodeName: child?.nodeName ?? "",
      childNodeType: child?.nodeType ?? -1,
    },
  });
}

/** Solo para tests: limpia el dedupe entre casos. */
export function __resetDedupe() {
  reported.clear();
}
